import { List } from 'immutable';
import * as cons from './constants';

// const simpleReducerUi = (cons, state, action) => {
//   if (action.type === cons.SUCCESS) {
//     return {
//       ...state,
//       ...action
//     };
//   }
//   return state;
// };

const errorsInfo = (state = new List(), action) => {
  if (action.type === cons.RESET_ERRORS.REQUEST_UPDATE) {
    state = new List();
  } else {
    for (const con in cons) {
      switch (con) {
        case cons.AUTH_LOGIN.SUCCESS:
          state = state.filter((error) => error && error.error && error.error.statusCode !== 401);
          break;
        default:
          if (action.type == cons[con].FAILURE) {
            state = state.push(action);
          }
          break;
      }
    }
  }
  return state;
};

export default {
  errorsInfo,
};
